import React, { useEffect, useMemo, useState } from 'react';
import './ChoiceSelector.scss';
// Generic, unstyled choice selector for onboarding and other simple flows.
// - Renders native radio/checkbox inputs (no CSS).
// - items: [{ id: string, displayString: string }]
// - isMultipleSelection: when true, uses checkboxes; otherwise radios
// - isRandomize: optional shuffle of items
// - defaultSelectedIds: string | string[]
// - onSelect: (ids: string[]) => void  // called on every change
// - isConfirmationNeeded: default false; when false, onConfirm(ids) is called on every change
// - onConfirm: (ids: string[]) => void

const ChoiceSelector = ({
  items = [],
  isMultipleSelection = false,
  isRandomize = false,
  defaultSelectedIds,
  onSelect,
  isConfirmationNeeded = false,
  onConfirm,
  isCards = false,
  cardsLarge = false
}) => {
  const normalizedDefault = useMemo(() => {
    if (!defaultSelectedIds) return [];
    return Array.isArray(defaultSelectedIds) ? defaultSelectedIds : [defaultSelectedIds];
  }, [defaultSelectedIds]);

  const displayedItems = useMemo(() => {
    if (!isRandomize) return items;
    const copy = [...items];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  }, [items, isRandomize]);

  const [selected, setSelected] = useState(normalizedDefault);
  const [failedImageById, setFailedImageById] = useState({});

  useEffect(() => {
    // initialize notify
    if (selected && selected.length && onSelect) onSelect(selected);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (id) => {
    let next;
    if (isMultipleSelection) {
      if (selected.includes(id)) next = selected.filter((x) => x !== id);
      else next = [...selected, id];
    } else {
      next = [id];
    }
    setSelected(next);
    onSelect && onSelect(next);
    if (!isConfirmationNeeded && onConfirm) onConfirm(next);
  };

  return (
    <ul className={"choice-selector " + (isCards && "choice-selector-cards-container")}>
      {displayedItems.map((item) => {
        const checked = selected.includes(item.id);
        return (
          <li key={item.id} className={"choice-selector-li" + (cardsLarge ? " choice-selector-li--large" : "")}>
            <label
              className={
                "choice-selector-item noselect" +
                (isCards ? " choice-selector-item-card" : "") +
                (cardsLarge ? " choice-selector-item-card-large" : "") +
                (checked ? " is-checked" : "")
              }
            >
              <input
                className="choice-selector-input"
                type={isMultipleSelection ? "checkbox" : "radio"}
                name="choice-selector-group"
                checked={checked}
                onChange={() => handleChange(item.id)}
              />
              {isCards && (
                (item.image || item.imageSrc) && !failedImageById[item.id] ? (
                  <div className="choice-selector-item-image">
                    <img
                      src={item.image || item.imageSrc}
                      alt={item.displayString}
                      onError={() => setFailedImageById((s) => ({ ...s, [item.id]: true }))}
                    />
                  </div>
                ) : (
                  <div className="choice-selector-item-emoji">{item.emoji}</div>
                )
              )}
              <span className="choice-selector-item-title">{item.displayString}</span>
            </label>
          </li>
        );
      })}
    </ul>

  );
};

export default ChoiceSelector;


